module.exports = require("@swa-ui/dotcom/src/DesktopHeaderControl/CustomerInformation.module.scss");